import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { getUserData } from '../../Services/oneSignalService';
import NotificationForm from './NotificationForm';

function UserManagement() {
  const { t } = useTranslation(); // Initialize translation hook
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const data = await getUserData();
        setUsers(data.players);
      } catch (error) {
        console.error(t('errorFetchingUsers'), error); // Log error with translation
      }
    };
    fetchUsers();
  }, [t]);

  const filteredUsers = users.filter(user =>
    ((user.tags && user.tags.name) || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
    (user.identifier || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleModal = (user) => {
    setSelectedUser(user);
    setModalOpen(!modalOpen);
  };

  return (
    <div>
      {/* <Input
        placeholder={t('searchUsers')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-3"
      /> */}
      <Table responsive>
        <thead>
          <tr>
            <th>{t('name')}</th>
            <th>{t('email') + " / ID"}</th>
            <th>{t('lastActive')}</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((user) => (
            <tr key={user.id}>
              <td>{user.tags && user.tags.name ? user.tags.name : t('notAvailable')}</td>
              <td>{user.identifier || t('notAvailable')}</td>
              <td>{new Date(user.last_active * 1000).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal isOpen={modalOpen} toggle={() => toggleModal(null)}>
        <ModalHeader toggle={() => toggleModal(null)}>
          {t('sendNotificationTo', {
            user: selectedUser && selectedUser.tags && selectedUser.tags.name
              ? selectedUser.tags.name
              : t('user'),
          })}
        </ModalHeader>
        <ModalBody>
          <NotificationForm />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => toggleModal(null)}>{t('close')}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default UserManagement;
